webpackJsonp([96199286130637],{

/***/ 401:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _ArvindThakur = __webpack_require__(99);
	
	var _ArvindThakur2 = _interopRequireDefault(_ArvindThakur);
	
	var _Deepak_Kapoor_new = __webpack_require__(100);
	
	var _Deepak_Kapoor_new2 = _interopRequireDefault(_Deepak_Kapoor_new);
	
	var _LalitaGupte = __webpack_require__(101);
	
	var _LalitaGupte2 = _interopRequireDefault(_LalitaGupte);
	
	var _ManishaGirotra = __webpack_require__(102);
	
	var _ManishaGirotra2 = _interopRequireDefault(_ManishaGirotra);
	
	var _padmajaRuparel = __webpack_require__(108);
	
	var _padmajaRuparel2 = _interopRequireDefault(_padmajaRuparel);
	
	var _persistentRoshiniBakshi = __webpack_require__(110);
	
	var _persistentRoshiniBakshi2 = _interopRequireDefault(_persistentRoshiniBakshi);
	
	var _Soumya_Rajan_new = __webpack_require__(148);
	
	var _Soumya_Rajan_new2 = _interopRequireDefault(_Soumya_Rajan_new);
	
	var _sujoyBose = __webpack_require__(111);
	
	var _sujoyBose2 = _interopRequireDefault(_sujoyBose);
	
	var _VT = __webpack_require__(105);
	
	var _VT2 = _interopRequireDefault(_VT);
	
	var _geeta = __webpack_require__(106);
	
	var _geeta2 = _interopRequireDefault(_geeta);
	
	var _neelam = __webpack_require__(107);
	
	var _neelam2 = _interopRequireDefault(_neelam);
	
	var _nithya = __webpack_require__(150);
	
	var _nithya2 = _interopRequireDefault(_nithya);
	
	var _pallavi = __webpack_require__(109);
	
	var _pallavi2 = _interopRequireDefault(_pallavi);
	
	var _SanjeevKrishnan = __webpack_require__(103);
	
	var _SanjeevKrishnan2 = _interopRequireDefault(_SanjeevKrishnan);
	
	var _ShwetaJalan = __webpack_require__(104);
	
	var _ShwetaJalan2 = _interopRequireDefault(_ShwetaJalan);
	
	var _VivekGambhir = __webpack_require__(149);
	
	var _VivekGambhir2 = _interopRequireDefault(_VivekGambhir);
	
	var _Harsh = __webpack_require__(78);
	
	var _Harsh2 = _interopRequireDefault(_Harsh);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var icon18 = "https://www.winpeforum.com/assets/elements/MatangiGowrishankar.png";
	var icon19 = "https://www.winpeforum.com/assets/elements/RoshiniBakshi.jpg";
	var icon20 = "https://www.winpeforum.com/assets/elements/VineetRai.png";
	var icon21 = "https://www.winpeforum.com/assets/elements/KanwaljitSingh.png";
	var icon22 = "https://www.winpeforum.com/assets/elements/ShirishGodbole.png";
	var icon23 = "https://www.winpeforum.com/assets/elements/VaibhavGupta.png";
	var icon24 = "https://www.winpeforum.com/assets/elements/SheebuDavid.png";
	var mentors_constants = [{
		imgUrl: _ArvindThakur2.default,
		into: "Mr Arvind Thakur has been the CEO, Vice Chairman & Managing Director at NIIT Technologies Ltd",
		desc: "Mr Arvind Thakur has been the CEO, Vice Chairman & Managing Director at NIIT Technologies Ltd, (now renamed as Coforge Limited) a global IT solutions organisation, which was spun off from NIIT Ltd in 2004. He led the company since inception till May 2019, to be among the top IT Services provider from the country. In 2012 he was conferred the prestigious Gold Stevie global award as \"Executive of the Year\" in the Computer Services category.<br/><br/>\n \n\t\tCurrently he serves on the Board of Management of NIIT University, a leading not for profit institution, the board of JK Technosoft Ltd, as non-executive director, and the board of National Skill Development Corporation (NSDC), a one of its kind public private partnership which aims to promote skill development in India.<br/><br/>\n\t\t \n\t\tIn the past he had served on the boards of several companies and was the Chairman at specialized tech companies like Esri India Technologies Ltd and Incessant Technologies Ltd.<br/><br/>\n\t\t \n\t\tMr Thakur has been an elected member of the Executive Council at NASSCOM, the apex IT industry association, for 3 consecutive terms till May 2020, where he held key positions to shape the industry including Chairman, Domestic Council and served as Chairman, Finance and Audit Committee. Currently he serves as a trustee on the board of Nasscom Foundation which aims to leverage tech for good to uplift marginalised sections of society.\n\t\t<br/><br/>\n\t\tHe has also served on the National Council of the Confederation of Indian Industries (CII) as the Chairman of the National Committee on IPR, and was a member of the Indo Spanish CEO Forum supported by Federation of Indian Chamber of Commerce & Industry (FICCI).<br/><br/>\n\t\t \n\t\tMr. Thakur graduated in engineering from IIT, Kharagpur where he received the Institute Silver medal. Thereafter he pursued post graduation in Industrial Engineering from NITIE, Mumbai which has conferred on him the \"Distinguished Alumnus Award\". He is actively involved in alumni activities and serves as the Vice President of the Technology Alumni Association (IIT Kharagpur, Delhi Chapter).<br/><br/>\n\t\t \n\t\tHe started his professional career with BHEL as an Industrial Engineer. Thereafter, after a brief stint with a start up he teamed up with the founders of NIIT in 1985 and is part of the promoter group at NIIT Ltd.\n\t\t<br/><br/> \n\t\tHis leisure time is engaged in golf.\n\t\t",
		name: "Arvind Thakur",
		post: "Member, Board of Management",
		cmp: "NIIT University",
		link: "https://in.linkedin.com/in/arvind-thakur-6b411096"
	
	}, {
		imgUrl: _Harsh2.default,
		into: " ",
		desc: "Accomplished business leader with expertise in Emerging Markets investing, building highly profitable investment businesses from the scratch, and setting and growing up multiple investment platforms.\n        <br/><br/>\n\t\tSpotted trends early on and used this to build large investments through platform, in a manner that assets are well diversified to optimize returns.\n\t\t<br/><br/>\n\t\tEarly investor in Sustainability for 15 years, built platforms, and invested in global technology businesses. During his career he has worked on financial investments across products and industries; advised CEOs on businesses and financial strategy, and built teams.\n\t\t<br/><br/>\n\t\tKey career highlights include building IFC\u2019s renewable investing business, conceptualizing and building India\u2019s largest road platform and setting up CDPQ India business across public equity, private equity, infra and fixed income.\n\t\t<br/><br/>\n\t\tThrough these journeys he has gained rich experience in scaling up businesses, driving sustainability, and corporate governance. Leading large global projects in multi-country and cultural setting. Negotiating documents under international tax and corporate laws. Building value creation strategies, executing these and steering organizational change.",
		name: "Harsh Singhal",
		post: "Founding Partner",
		cmp: "Edhina Capital",
		link: "https://www.linkedin.com/in/harsh-singhal-8321844/?originalSubdomain=in"
	
	}, {
		imgUrl: icon21,
		into: "Kanwal has always been passionate about mentoring and helping build consumer brands in India",
		desc: "Kanwal has always been passionate about mentoring and helping build consumer brands in India, and has been involved as an investor with brands like Paper Boat, ID Fresh, Epigamia, and Licious, before starting Fireside. He has been investing in the early stage ecosystem in India for the past 17 years, first as a Director at Carlyle Group, India, and later as a Co-Founder and Senior Managing Director of Helion Venture Partners. Prior to his investing career, Kanwal spent over 13 years in consumer marketing with Hindustan Unilever, and Intel India.\n\t\t",
		name: "Kanwaljit Singh",
		post: "Managing Partner",
		cmp: "Fireside Ventures",
		link: "https://in.linkedin.com/in/singhkanwaljit"
	}, {
		imgUrl: _nithya2.default,
		into: "Nithya has over 24 years of rich experience in financial services. She is Managing Director of Multiples Alternate Asset Management,  a private equity platform with AUM of over US$1.5 billion. ",
		desc: "Nithya has over 24 years of rich experience in financial services. She is Managing Director of Multiples Alternate Asset Management, a private equity platform with AUM of over US$1.5 billion.<br/><br/>\n \n\t\tNithya joined Multiples in 2010 and has led several investments made by the platform. She is a Director on the Board of Multiples and a part of the Investment Committee. She leads the financial sector investing practice and focuses on creating a franchise with top corporate houses. Nithya developed Multiples\u2019 proprietary framework - Leadership Energy Level - to analyze the DNA of entrepreneurs.<br/><br/>\n\t\t \n\t\tNithya is a Director on the Board of Arvind Fashions and APAC Financial Services. She is a founding member of the India Chapter of Bloomberg Women\u2019s Buyside Network. The Association of International Wealth Management of India featured her amongst India\u2019s Top 100 Women in Finance 2020.<br/><br/>\n\t\t \n\t\tPrior to joining Multiples, Nithya had a 14-year banking career across Citibank and ICICI focused on structured finance. In her banking stint, she has pioneered several unique securitisation, mezzanine debt and leveraged finance transactions. She holds an engineering degree from VJTI, Mumbai and an MBA from IIM, Lucknow.\n\t\t<br/><br/>\n\t\tNithya enjoys spending time with her teenage son, loves reading and connecting with nature. She dedicates time over the weekends for teaching Maths to disadvantaged children.\n\t\t\n       </div>",
		name: "Nithya Easwaran",
		post: "Managing Director",
		cmp: "Multiples Alternate Asset Management",
		link: "https://www.linkedin.com/in/nithyaeaswaran"
	}, {
		imgUrl: _padmajaRuparel2.default,
		into: "Padmaja Ruparel is nationally recognized as a key player in the Indian",
		desc: "Padmaja Ruparel is nationally recognized as a key player in the Indian entrepreneurial ecosystem and has helped co-found many of the relevant institutions, besides being an active angel investor herself. Her operating experience spans large corporates, M&A, and startups/early stage companies. She has been awarded as one of the 'Top 50 Most Powerful Women in Business' by Fortune India for 2017, 2018, 2019 and listed in Forbes India\u2019s W- Power Trailblazers and \u201C30 Most Powerful Women in India\u201D by Business Today for 3 years running. The Women Economic Forum recognized her with its \u201CWomen of the Decade in Investment Banking\u201D award.<br/><br/>\n \n\t\tShe is Co-Founder & President of Indian Angel Network (IAN), India's first and now possibly one of the world\u2019s largest group of business angels, comprising the who's who of successful entrepreneurs and dynamic CEOs from India and overseas. She built IAN from inception, making it within 15 years a unique institution globally, with close to 500 investors across 10 countries and a portfolio of 160+ companies in 7 countries, spanning 17 sectors. She has operationalised IAN\u2019s international operations in London \u2013 making it the only angel group in the world to set up operations outside of its home country. Padmaja has been nominated as Co-Chair of Global Business Angel Network (GBAN). She is a member of the National Expert Advisory Committee on Innovation, Incubation and Technology Entrepreneurship. She is a member of several committees of BIRAC (Dept. of Biotech, Govt. of India), various committees of Ministry of Finance, DPIIT, & SEBI.<br/><br/>\n\t\t \n\t\tIn an attempt to realise IAN\u2019s vision of investing in 500 startups, investing Rs. 5,000 crores and create 500,000 jobs, Padmaja launched the IAN Fund I, a uniquely differentiated Fund which along with IAN, is set to create the largest horizontal platform in India for investing in seed and early stage ventures. With this Fund, IAN has today invested about Rs. 900 crores which has catalysed Rs. 18,000 crores. Today, the IAN portfolio comprises 3 unicorns, 5 soonicorns and the market valuation of its investee companies stands at over US$9bn.<br/><br/>\n\t\t \n\t\tShe is a member of the Governing Council of EM3 Services, a nation building venture seeking to create a paradigm shift in the Indian agricultural sector by improving productivity. She helped the company raise funds from an international Venture Capital fund and is actively involved in its strategy and growth. Padmaja is an Independent Director on the Boards of Avendus Finance Pvt. Ltd. & Ester Industries Ltd.<br/><br/>\n\t\t \n\t\tApart from co-founding IAN, she also set up and operationalised the Delhi chapter of The Indus Entrepreneurs (TIE) the world\u2019s largest organization focused on entrepreneurship with over 16,000 members across more than 60 chapters across 14 countries. She also established a unique model of an incubator, in partnership with the Indian Government, which leverages 400 mentors to provide mentoring & domain expertise to around 50 young fledgling incubatee companies. She played a key role as Executive Director in building the Indian Venture Capital Association, India's oldest and largest association of VC and PE firms. Currently, she is a member of IVCA\u2019s Limited Partners Council.\n\t\t<br/><br/>\n\t\tIn addition, she helped the creation of Lankan Angel Network in Sri Lanka. She contributed actively in the Planning Commission\u2019s Committee on \u201CAngel & Early Stage Investing in India\u201D which resulted in a seminal report: \u201CCreating a Vibrant Entrepreneurial Ecosystem in India\u201D.\n\t\t<br/><br/>\n\t\tIn her corporate avatar at Xansa India, (Xansa was a US$800mn company listed on LSE before being acquired by Steria), she led several functions over a 16 year period : handled recruitment operations, built and successfully executed an innovative brand and communication strategy and led the corporate social responsibility initiative which engaged employees, clients as also the government.\n\t\t<br/><br/>\n\t\tShe was a key member of the corporate strategy and M&A team as the Company went public, forged joint ventures and the final acquisition of the Indian company.\n\t\t<br/><br/>\n\t\tPadmaja picked up entrepreneurial strings very early in her career \u2013 she revived and grew the family real estate business in Calcutta \u2013 growing from 50,000 sq ft to over 250,000 sq ft over 2 years and turned it around to become a profitable business.\n\t\t<br/><br/>\n\t\tA graduate with English Honours, Padmaja then completed her MBA as well as Chartered Accountancy (Intermediate) with her internship with S.R. Batliboi (an E&Y group company).\n\t\t",
		name: "Padmaja Ruparel",
		post: "Co-Founder & President",
		cmp: "Indian Angel Network ",
		link: "https://in.linkedin.com/in/padmajaruparel"
	}, {
		imgUrl: _pallavi2.default,
		into: "Pallavi is a Partner in the International Capital Markets practice and is also the Joint Chair of Allen & Overy's India Group",
		desc: "Pallavi is a Partner in the International Capital Markets practice and is also the Joint Chair of Allen & Overy's India Group. Pallavi\u2019s practice focuses on debt and equity capital markets transactions in India and across the Asia Pacific region where she has over 18 years of experience advising issuers, underwriters and sponsors on Rule 144A and Regulation S international debt offerings, equity-linked offerings of exchangeable and convertible bonds, and equity offerings.<br/><br/>\n \n\t\tPallavi also has significant experience in bond restructurings, consent solicitations, exchange offers, induced conversions and tender offers. Many of the transactions she has advised on have been complex, innovative and award-winning.<br/><br/>\n\t\t \n\t\tPallavi is qualified as a solicitor in India, England and Wales and Singapore.<br/><br/>\n\t\t \n\t\tPallavi is consistently ranked in leading benchmarking publications. She is ranked as a highly regarded practitioner in IFLR1000 2019 and listed in the top 100 India-focused legal experts outside the country by India Business Law Journal. Clients say \u201CPallavi is considered a debt specialist, and well known for her focus on the Indian market.\u201D Chambers Asia Pacific describes her as \u201Cmeticulous and detail-oriented, has excellent legal skills and an ability to work well with Indian clients and Indian lawyers and a great deal lawyer and an asset to the team.\u201D Asia Pacific Legal 500 states that Pallavi is \u201Cextremely strong on knowledge, professionalism and accessibility\u201D and is \u201Cbusiness-friendly and willing to work at solving problems\u201D.\n\t\t",
		name: "Pallavi Gopinath Aney",
		post: "Partner",
		cmp: "Allen & Overy",
		link: "https://www.linkedin.com/in/pallavi-gopinath-aney-5922292/"
	
	}, {
		imgUrl: icon19,
		into: " ",
		desc: "Roshini is the Managing Director, Private Equity at Everstone Capital Asia Pte and the Head of Impact for the entire group. As an MD , she is focused on evaluating new opportunities, including thematic strategies in the consumer sector, and driving operational improvement in portfolio companies in the areas of, human capital management, brand transformation and implementation of ESG and Impact. She manages a diverse portfolio of companies based in India, and South East Asia as part of her remit.\n \n\t\t<br/><br/>\n\t\tRoshini has more than 30 years of general management and marketing experience and strong track record in consumer industries, setting strategy for creative consumer-driven services and improving operational effectiveness to create greater financial returns. Prior to Everstone, she was the CEO for the Walt Disney Company\u2019s consumer, media and retail business for South Asia, where she set up and grew the business to more than $300 million in revenue. Some of her earlier roles were with Unilever, American Express, Mattel and Polaris.\n\t\t<br/><br/>\n\t\tRoshini serves on the boards of Persistent Systems, JM Financial Products as an Independent Director and on Everlife Pte, Singapore and Culinary Brands , India as a nominee director. She believes very strongly in young entrepreneurs as the future for innovation and growth and works closely with Endeavor.org as a mentor and global panelist helping shortlist the next generation of growth businesses.\n\t\t<br/><br/>\n\t\tRoshini holds an MBA from the Indian Institute of Management (Ahmedabad, India) and an undergraduate degree in economics from St Stephens College (Delhi, India).She lives in Jakarta and works from Singapore across India, South East Asia and North America. She is a keen marathoner and passionate about running, finding a way to run wherever she travels.\n\t\t",
		name: "Roshini Bakshi",
		post: "Managing Director",
		cmp: "Private Equity, Everstone Capital Asia",
	
		link: "https://sg.linkedin.com/in/roshini-bakshi-2841702"
	}, {
		imgUrl: _SanjeevKrishnan2.default,
		into: " ",
		desc: "<div>Sanjeev Krishan is the Chairman of PwC in India. Previously, he served as the Deals leader. Sanjeev has been with the firm for 30 years. He has successfully led the firm\u2019s Transactions, Private Equity and Deals business over the years, getting the firm to a pre-eminent position amongst its Private Equity clients and their investee companies.  \n\t\t<br/><br/>\n\t\tSanjeev has served in diverse leadership and client service roles and has extensive India and overseas experience in Deals, working across a range of sectors, such as technology, consumer and industrial products. Among his prior roles, he was a member of the team that set up the Transaction Services practice in India, and he has spearheaded the relationship with most global private equity funds, personally looking to raise the firm\u2019s focus on numerous funds. Sanjeev did a brief stint with PwC Sweden as part of an International Exchange programme, where he worked with several Private Equity funds and Corporate clients, mostly on cross-border deals.  \n\t\t<br/><br/>\n\t\tSanjeev frequently interacts with the media on various issues ranging from insolvency to mergers and acquisitions. Additionally, he regularly participates in seminars, panel discussions and events held in India, as well as overseas, and is also part of FICCI\u2019s National Committee on Stressed Assets. Sanjeev is a member of the Rotary Club of Delhi, South.  \n\t\t<br/><br/>\n\t\tSanjeev is passionate about playing a part in building a sustainable future for the society we live in, and actively advocates the causes of conservation, socio-economic inclusion and diversity. He has also been specifically focused on the sponsorship and retention of women employees.  \n\t\t<br/><br/>\n\t\tHe is a certified Chartered Accountant, and an Associate Member of the Institute of Chartered Accountants of India (ICAI). Sanjeev graduated with First Class in Economics from the University of Delhi and remains an active and proud alum.  \n\t\t<br/><br/>\n\t\tA nature lover, Sanjeev enjoys his morning walks and exercise regimen. He is also a cricket enthusiast and enjoys playing squash.  \n       </div>",
		name: "Sanjeev Krishan",
		post: "Chairman",
		cmp: "PwC India",
		link: "https://in.linkedin.com/in/sanjeev-krishan"
	
	}, {
		imgUrl: icon24,
		into: "Sheebu David",
		desc: " \n\t\t",
		name: "Sheebu David",
		post: " Executive Vice President - Corporate HR & Ethics",
		cmp: "Mahindra & Mahindra",
		link: "https://in.linkedin.com/in/sheebu-david-b052742"
	
	}, {
		imgUrl: icon22,
		desc: "Shirish brings a wealth of experience with over 30 years in the real estate sector across US, UK and India. He has worked with leading global companies including Morgan Stanley and Goldman Sachs in investing and lending roles across different geographies. More recently, he has been an active venture investor in real estate related businesses. His vision to identify an obviously large problem in the real estate upgrade market and a solution for the same, was the foundation for the creation of Homexchange.",
		name: "Shirish Godbole",
		post: "Co-Founder & Chairman",
		cmp: "Homexchange",
		link: "https://in.linkedin.com/in/shirish-godbole-5540b61a0"
	}, {
		imgUrl: icon23,
		into: "Vaibhav Gupta",
		desc: "Vaibhav Gupta is the CEO and Co-founder of udaan. He founded udaan in 2016 along with Amod Malviya and Sujeet Kumar, both former senior executives at Flipkart.<br/><br/>\n \n\t\tPrior to founding udaan, Vaibhav held several leadership roles over a 5-year period at Flipkart. Most notably, he built and scaled Flipkart\u2019s Business Finance & Analytics function. \n\t\t",
		name: "Vaibhav Gupta",
		post: "CEO / Founder",
		cmp: "Udaan",
		link: "https://in.linkedin.com/in/vaibhav-gupta-629568"
	
	}, {
		imgUrl: icon20,
		into: "Vineet Rai is the Founder and Chairman of Aavishkaar Group, an Impact Investment Platform impacting millions using an entrepreneurship based development based approach",
		desc: "Vineet Rai is the Founder and Chairman of Aavishkaar Group, an Impact Investment Platform impacting millions using an entrepreneurship based development based approach The Group includes Aavishkaar Capital, Arohan, Ashv Finance Intellecap & Sankalp, has 7000+ employees & manages assets in excess of US $ 1.2 Billion.<br/><br/>\n\t\tVineet has received numerous awards including the TiE Hall of Fame 2018, the Impact Investor of the Year by News Corp 2016, Porter Prize for Strategic Leadership in Social Space, 2016, CNBC TV 18 Award for being the Catalyst Fund for India 2016, G 20 \u2013 SME Innovation in Finance Award 2010, UNDP-IBLF \u2013ICC World Business Award in 2005 and Lemelson Award for Social Venture Investing.<br/><br/>\n\t\t \n\t\tHe is an Ashoka Fellow and Honorary Member of XLRI. Vineet has been featured\n\t\ton the cover of Forbes India, January 2018 issue.<br/><br/>\n\t\t \n\t\tIn 2022, Vineet was invited by the Hon\u2019ble PM Shri Narendra Modi for his \u201CRoundtable interaction with Venture Capital and Private Equity Funds\u201D. In 2021, Vineet received appreciation by Hon\u2019ble Finance Minister Smt. Nirmala Sitharaman on the Aavishkaar Group Impact Report 2021. Vineet has also worked with the Hon\u2019ble PM Shri Narendra Modi for consultations on doubling the income of the farmers. Vineet also serves as Commissioner at the BCSD, as Senior Advisor to Blended Finance Working Group at OECD and as an Advisor to United Nations Economic and Social Commission for Asia and the Pacific Science Technology and Innovation Advisory Board. <br/><br/>\n\t\t \n\t\tVineet Rai was recently awarded and recognized for Championing Financial Inclusion at the13th Inclusive Finance India Awards 2021. Earlier last year, Vineet Rai and Swati Rai (Co-Founder) was awarded the Faces of Vibrant Bharat 2021 by Grant Thorton Bharat.\n\t\t\n\t\t",
		name: "Vineet Rai",
		post: "Founder & Chairman",
		cmp: "Aavishkaar Group",
		link: "https://in.linkedin.com/in/vineet-rai-536160"
	}, {
		imgUrl: _VT2.default,
		into: "VT Bharadwaj is a co-founder and General Partner at A91 Partners",
		desc: "VT Bharadwaj is a General Partner at A91 Partners, an Indian private investment firm that seeks to partner with founders to build enduring businesses for tomorrow\u2019s India.<br/><br/>\n \n\t\tPrior to co-founding A91 Partners, VT was a Managing Director at Sequoia Capital, a global venture capital firm in India where he led investments in consumer, pharmaceutical and healthcare sectors. Prior to that he worked at McKinsey & Co.<br/><br/>\n\t\t \n\t\tVT has an MBA from Indian Institute of Management Ahmedabad and a BE (Hons) in Electrical and Electronics Engineering from BITS Pilani\n\t\t<br/><br/>\n\t\tVT is a trustee at Ashoka University, a board member of IIM Ahmedabad Endowment Management Company, a Founding Circle member of Museum of Art & Photography and involved with Cuddles Foundation and Swasth Foundation.\n\t\t",
		name: "VT Bharadwaj",
		post: "Co-founder and General Partner",
		cmp: "A91 Partners",
		link: "https://in.linkedin.com/in/vt-bharadwaj-2333ba1"
	}];
	
	exports.default = mentors_constants;
	module.exports = exports["default"];

/***/ }),

/***/ 409:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Mentors = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(567);
	
	var _Modal = __webpack_require__(21);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	__webpack_require__(19);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _contentPage = __webpack_require__(16);
	
	var _contentPage2 = _interopRequireDefault(_contentPage);
	
	var _meta = __webpack_require__(17);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _mentors = __webpack_require__(401);
	
	var _mentors2 = _interopRequireDefault(_mentors);
	
	var _knowledgeCenter = __webpack_require__(44);
	
	var _knowledgeCenter2 = _interopRequireDefault(_knowledgeCenter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamModal = function TeamModal(_ref) {
		var activeItem = _ref.activeItem,
		    show = _ref.show,
		    onHide = _ref.onHide;
	
		return _react2.default.createElement(
			_Modal2.default,
			{ direction: '', className: 'teamdetails__wrapper', show: show, onHide: onHide },
			_react2.default.createElement(
				_Modal2.default.Header,
				null,
				_react2.default.createElement(
					'div',
					{ className: 'head_section' },
					_react2.default.createElement(
						'span',
						{ className: 'item_name' },
						activeItem.name
					),
					_react2.default.createElement(
						'div',
						{ className: 'item_des' },
						activeItem.post
					),
					_react2.default.createElement(
						'div',
						{ className: 'item_des' },
						activeItem.cmp
					)
				),
				_react2.default.createElement(
					'span',
					{ className: 'cross pull-right' },
					_react2.default.createElement('i', { onClick: onHide, className: 'fa fa-times' })
				)
			),
			_react2.default.createElement(
				_Modal2.default.Body,
				null,
				_react2.default.createElement(
					'div',
					{ className: 'item__desc' },
					_react2.default.createElement('div', { className: 'item__desc_scr', style: { padding: "0px 10px 0px 0px" }, dangerouslySetInnerHTML: { __html: activeItem.desc } })
				)
			),
			_react2.default.createElement(_Modal2.default.Footer, null)
		);
	};
	
	TeamModal.propTypes = {
		activeItem: _propTypes2.default.object,
		show: _propTypes2.default.object,
		onHide: _propTypes2.default.object
	};
	
	var Mentors = exports.Mentors = function (_React$Component) {
		_inherits(Mentors, _React$Component);
	
		function Mentors(args) {
			_classCallCheck(this, Mentors);
	
			var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
			_this.togglePopUp = function (item) {
				_this.setState({
					isShow: !_this.state.isShow,
					activeItem: item || {}
				});
			};
	
			_this.state = {
				activeItem: {},
				isShow: false
			};
			return _this;
		}
	
		Mentors.prototype.render = function render() {
			var _this2 = this;
	
			var location = this.props.location;
			var isShow = this.state.isShow;
	
			return _react2.default.createElement(
				_contentPage2.default,
				null,
				_react2.default.createElement(_meta2.default, { title: 'Winpe ProClub Mentorship Program | Mentors', description: 'Our mentors include eminent industry leaders who have had a rich professional and leadership journey and who are now keen to support the growth of female talent into future leaders.', image: "https://winpeforum.com/assets/elements/winpe_proclub_updated_linkimage1.jpg", location: location }),
				_react2.default.createElement(
					'div',
					{ className: 'mentors-wrapper' },
					_react2.default.createElement(
						'section',
						{ id: 'team', className: 'pb-5' },
						_react2.default.createElement(
							'div',
							{ className: 'container' },
							_react2.default.createElement(
								'h1',
								{ className: 'section-title h1' },
								'Mentors',
								_react2.default.createElement('br', null),
								'Cohort III'
							),
							_react2.default.createElement(
								'div',
								{ className: 'section_intro_text' },
								'Our mentors include eminent industry leaders who have had a rich professional and leadership journey and who are now keen to support the growth of female talent into future leaders.'
							),
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_mentors2.default.map(function (item, i) {
									return _react2.default.createElement(
										'div',
										{ className: 'col-xs-12 col-sm-6 col-md-4' },
										_react2.default.createElement(
											'div',
											{ className: '' },
											_react2.default.createElement(
												'div',
												{ className: 'mainflip flip-0', style: { minHeight: '450px' } },
												_react2.default.createElement(
													'div',
													{ className: 'frontside' },
													_react2.default.createElement(
														'div',
														{ className: 'card' },
														_react2.default.createElement(
															'div',
															{ className: 'card-body text-center mt-4' },
															_react2.default.createElement(
																'p',
																null,
																_react2.default.createElement('img', { onClick: function onClick() {
																		return _this2.togglePopUp(item);
																	}, className: ' img-fluid', src: item.imgUrl, alt: item.name })
															),
															_react2.default.createElement(
																'div',
																{ className: 'car_title' },
																item.name
															),
															_react2.default.createElement(
																'div',
																{ className: 'car_text1' },
																item.post
															),
															_react2.default.createElement(
																'div',
																{ className: 'car_text1' },
																item.cmp
															),
															_react2.default.createElement(
																'div',
																{ className: 'car_text', style: { height: 'auto' } },
																item.cohort
															),
															_react2.default.createElement(
																'a',
																{ target: '_blank', href: item.link, className: 'btn btn-primary btn-sm' },
																_react2.default.createElement('i', { className: 'fa fa-linkedin' })
															)
														)
													)
												)
											)
										)
									);
								}),
								_react2.default.createElement(
									'div',
									{ className: 'col-xs-12 col-sm-6 col-md-4' },
									_react2.default.createElement(
										'div',
										{ className: '' },
										_react2.default.createElement(
											'div',
											{ className: 'mainflip flip-0' },
											_react2.default.createElement(
												'div',
												{ className: 'frontside' },
												_react2.default.createElement(
													'div',
													{ className: 'card' },
													_react2.default.createElement(
														'div',
														{ className: 'card-body text-center mt-4' },
														'\xA0'
													)
												)
											)
										)
									)
								)
							)
						),
						_react2.default.createElement(TeamModal, { show: isShow, onHide: this.togglePopUp, activeItem: this.state.activeItem })
					)
				)
			);
		};
	
		return Mentors;
	}(_react2.default.Component);
	
	Mentors.propTypes = {
		location: _propTypes2.default.object
	};
	
	exports.default = Mentors;

/***/ }),

/***/ 567:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-cohort-iii-mentors-index-jsx-51f4f239c54910adcc44.js